import React, {useState} from 'react';
import {Link} from "react-router-dom";

import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DomainTable from '../../components/domainTable.js'
import GeoDistribution from '../../components/geoDistribution.js'

import useGoogleCharts from '../../components/useGoogleCharts.js';
import CountriesLeadList from '../../components/countriesLeadList.js'
import TLDLeadList from '../../components/tldLeadList.js'

import {TagPageResult} from '../../../../server/routes/tag.js'

import {
	_printNumber, 
	_printPercent, 
	_extractWebsiteFromURL,
	_isGoogleIcon,
	_getGoogleIcon,
    _countryNameFromCode
	} from '../../helpers/helpers'

interface TAGIDProps {
	server: string,
	pageData: unknown;
}

export default function TAGID({server, pageData}: TAGIDProps) {

	const typedPageData = pageData as TagPageResult;

	const [data, setData] = useState(typedPageData);

	return (
		<>
			<section className="section section-sm">
				<div className="container">
					<div className="row row-50">
						<div className="col-md-8 col-lg-8 col-xl-8">
							<TechnologyLeftPanel props={data}/>
						</div>
						{
						<div className="col-md-4 col-lg-4 col-xl-4">
							<TechnologyRightPanel props={data} />
						</div>
						}						
					</div>
				</div>
			</section>
		</>
	)
}

interface ComponentProps {
	props: TagPageResult;
}

function NoDomainTechnology({props}: ComponentProps) { 

	return (
		<div className="row row-50">
			<div className="col-12">
				<p>We did not find any websites that are using tag ID {props.tag} </p>
			</div>
		</div>
	)
}

function TechnologyLeftPanel({props}: ComponentProps) {
	return (
		<>
			<h2 style={{wordWrap: 'break-word'}}>{props.PageTitle}</h2>
            Tag ID - {props.tag}
			<hr/>
			{
				!props.DomainCount && 
					<NoDomainTechnology props={props}/>
			}
			{
				props.DomainCount !== 0 &&
					<HasDomainTechnology props={props}/>
			}
		</>
	)
}

function TechnologyAvailableReports({props}: ComponentProps) {
    if (!props || !props.DomainCount) return null;

	return (
		<>
			<article className="box-bordered">
				<h4>Available Reports</h4>
				<br/>
				<div>
					<ul>
						<li>
							<Link 
								to={`/tag/${props.tag}/websites`}
								className="link-hover" 
								title={`List of websites that are using ${props.tag}`}
							>
								Website List
							</Link>
						</li>       
					</ul>      
				</div>
			</article>
			<br />
		</>
	)
}

function TechnologyRightPanel({props}: ComponentProps) {
	return (
		<div className="row row-35 row-lg-50">
			<div className="col-sm-12 col-lg-12">
				<TechnologyAvailableReports props={props}/>

			    <CountriesLeadList name={props.tag} reporttype='none'  geoData={props.TechnologyGeoData} />
				<TLDLeadList name={props.tag} reporttype='none' tlds={props.TLDs}/>	
			</div>
		</div>
	)							
}

function HasDomainTechnology({props}: ComponentProps) {
	const google = useGoogleCharts();

	return (
		<>
			<TechnologyBrag props={props}/>

			<TechnologyUsageStats props={props}/>

			<GeoDistribution geoData={props.TechnologyGeoData} google={google}/>

			<TechnologyWebsites props={props}/>

		</>
	)
}

function TechnologyBrag({props}: ComponentProps) {
    const tag = props.tag;

	return (
		<>
			<br/>
			<p>
				We have discovered &nbsp;
				<Link 
					to={`/tag/${tag}/websites`}
					className="link-hover" 
					title={props.TechnologyDomains.Header!.Subtitle} 
					rel="noopener nofollow" 
				> 
				<b>{_printNumber(props.DomainCount)} live websites</b>
				</Link>&nbsp;that are using tag ID {tag}.
			</p>
			<p>		
			</p>
			<br />
		</>
	)
}

function TechnologyUsageStats({props}: ComponentProps) {

	return (
		<>
			<div className="row row-50">
			<div className="col-12">
				<h3 className="text-left">{props.tag} usage statistics</h3>
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
						<tr>
							<td>Websites using tag Id {props.tag}</td>
							<td>
								<span className="icon text-primary">
									<Link 
										to={`/tag/${props.tag}/websites`}
										className="link-hover" 
										title={`List of websites that are using ${props.tag}`} 
									>
										<b>{_printNumber(props.DomainCount)}</b> websites
									</Link>
								</span>
							</td>
						</tr>
						{
							props.TechnologyUsage !== undefined && props.TechnologyUsage.MostPopularCountry &&
    							<tr>
                                    <td>
                                        Most popular in the country
                                    </td>
                                    <td>
                                        <b>
                                            <CountryFlagAndName countryCode={props.TechnologyUsage.MostPopularCountry.Country} />
                                        </b>
                                    </td>
                                </tr>  
                        }
                        {    
							props.TechnologyUsage !== undefined && props.TechnologyGeoData.Countries && props.TechnologyUsage.DomainCount && props.TechnologyUsage.MostPopularCountry &&
                            <tr>
                                <td>
                                	Websites using {props.tag} hosted in {_countryNameFromCode(props.TechnologyUsage.MostPopularCountry.Country)}
                                </td>
                                <td>
                                    <b>
                                        {_printPercent(props.TechnologyGeoData.Countries[0].DomainCount/props.TechnologyUsage.DomainCount)}%
                                    </b>
                                </td>
                            </tr>
						}

					</tbody>
				</table>
			</div>
		</div>
	</>
	)
}

function TechnologyWebsites({props}: ComponentProps) {

	return (
		<DomainTable domainList={props.TechnologyDomains}/>
	)
}
